import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_10 = { class: "menu-item px-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_12 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_13 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_14 = { class: "menu-item px-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "media/flags/united-states.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_16 = { class: "menu-item px-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "media/flags/spain.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_18 = { class: "menu-item px-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "media/flags/germany.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_20 = { class: "menu-item px-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "media/flags/japan.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_22 = { class: "menu-item px-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "media/flags/france.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_24 = { class: "menu-item px-5 my-1" }
const _hoisted_25 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            alt: "Avatar",
            src: _ctx.userDetail.avatar
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.userDetail.fullName), 1),
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.userDetail.phone), 1)
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, {
        to: "/quan-ly/tai-khoan/thong-tin",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Hồ sơ của tôi ")
        ]),
        _: 1
      })
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('en'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('en') }])
          }, [
            _hoisted_15,
            _createTextVNode(" English ")
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('es'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('es') }])
          }, [
            _hoisted_17,
            _createTextVNode(" Spanish ")
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLang('de'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('de') }])
          }, [
            _hoisted_19,
            _createTextVNode(" German ")
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLang('ja'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('ja') }])
          }, [
            _hoisted_21,
            _createTextVNode(" Japanese ")
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLang('fr'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('fr') }])
          }, [
            _hoisted_23,
            _createTextVNode(" French ")
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_component_router_link, {
        to: "/quan-ly/tai-khoan/cap-nhat",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Cài đặt tài khoản ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("a", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Đăng xuất ")
    ])
  ]))
}